export class FetchAuthorization {
    public static readonly type = '[Auth] FetchAuthorization';
}

export class FetchAuthentication {
    public static readonly type = '[Auth] FetchAuthentication';
}
